import { useRouter } from 'next/router'

export function useSetFilterParameter(attributeId: number) {
  const { push, query } = useRouter()

  // Get the active filters for the current attribute
  let activeFilters = query[attributeId] ?? []
  if (typeof activeFilters === 'string') {
    activeFilters = [activeFilters]
  }

  function setFilterParam(value: number) {
    const oldFilterParam = query[attributeId] as string
    // Always remove the page parameter when setting a new filter
    let { [attributeId]: _, page, ...newQuery } = query

    if (oldFilterParam) {
      const filterValues = oldFilterParam.split(',')
      // Determine whether to add or remove the value
      const shouldRemoveValue = filterValues.includes(String(value))

      const newFilterValues = shouldRemoveValue
        ? filterValues.filter((v) => v !== String(value))
        : [...filterValues, String(value)]

      // Only add the param to the query if there are values
      if (newFilterValues.length) {
        newQuery[attributeId] = newFilterValues.join(',')
      }
    } else {
      newQuery[attributeId] = String(value)
    }

    push(
      {
        query: newQuery,
      },
      undefined,
      {
        shallow: true,
      },
    )
  }

  return {
    setFilterParam,
    activeFilters,
  }
}
